import { useCallback } from 'react';

import { useFiltersStore } from '@data-access';

/**
 * Results list filters: every change resets pagination in one store update
 * to avoid duplicate list/summary/map requests.
 */
export function useResultsColFilter<T = unknown>(name: string) {
  const value = useFiltersStore(
    (state) =>
      state.results.filters.find((f) => f.id === name)?.value as
        | T
        | undefined,
  );
  const setFilterAndResetPage = useFiltersStore(
    (state) => state.setFilterAndResetPage,
  );
  const resetFilterAndResetPage = useFiltersStore(
    (state) => state.resetFilterAndResetPage,
  );

  const setFilter = useCallback(
    (next: T) => setFilterAndResetPage('results', name, next),
    [name, setFilterAndResetPage],
  );

  const resetFilter = useCallback(
    () => resetFilterAndResetPage('results', name),
    [name, resetFilterAndResetPage],
  );

  return [value, setFilter, resetFilter] as const;
}
